import { render, staticRenderFns } from "./FreeForm.vue?vue&type=template&id=68be268e&"
import script from "./FreeForm.vue?vue&type=script&lang=js&"
export * from "./FreeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports